import { createApp } from 'vue'
//引入type.css
import "./assets/css/type.css";

import App from './App.vue'
import router from './router'
import store from './store'
import * as echarts from "echarts";
import jquery from "jquery";
import list from '@/components/list'
import listCard from '@/components/listCard'
import show from '@/components/show'
import bottom from '@/components/bottom'
import DynamicImage from '@/components/DynamicImage'
import verticalTimeline from '@/components/verticalTimeline'
import FAQ from '@/components/FAQ'
import sideNavigation from '@/components/sideNavigation.vue'
import detail from '@/components/detail.vue'
import pagination from '@/components/pagination.vue'
import support from '@/components/support.vue'
import business from '@/components/business.vue'
import detailsInfo from '@/components/detailsInfo.vue'



import ElementPlus from 'element-plus'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import axios from 'axios'

// 配置axios全局设置
axios.defaults.timeout = 100000; // 10秒超时
axios.defaults.baseURL = 'http://82.157.23.29:5001'; // 基础URL

// 添加响应拦截器，统一错误处理
axios.interceptors.response.use(
  response => response,
  error => {
    if (error.code === 'ECONNABORTED') {
      console.warn('请求超时:', error.config.url);
    } else if (error.response) {
      console.warn('服务器错误:', error.response.status, error.config.url);
    } else {
      console.warn('网络错误:', error.message);
    }
    return Promise.reject(error);
  }
);

const app=createApp(App)
app.config.globalProperties.$echarts = echarts;
// 配置axios成为 vue的全局变量
app.config.globalProperties.$axios=axios
app.component('list',list)
app.component('listCard',listCard)
app.component('show',show)
app.component('bottom',bottom)
app.component('DynamicImage',DynamicImage)
app.component('verticalTimeline',verticalTimeline)
app.component('FAQ',FAQ)
app.component('sideNavigation',sideNavigation)
app.component('detail',detail)
app.component('pagination',pagination)
app.component('support',support)
app.component('business',business)
app.component('detailsInfo',detailsInfo)

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

app.use(ElementPlus).use(store).use(router).use(jquery).mount('#app')


